import { FormElement } from "./FormElement";
import { DOMTemplate } from "../../denki";
import { node } from "../Util";
import { FieldInputElement } from "./FieldInputElement";
import { OptionType } from "../definition/OptionType";

export class FormCheckBoxElement extends FormElement<string[]> implements FieldInputElement {
  public readonly fieldsElement: HTMLElement;
  private readonly map: { [key: string]: HTMLInputElement } = {};

  constructor(name: string, options: OptionType[], template: DOMTemplate) {
    super(name, template.get("field-element"));
    this.fieldsElement = this.element.querySelector("[data-role=elements]");

    const fieldset = node('div', { "class": "checkbox_wrapper" });
    const id = name;
    this.virtualInput.setAttribute("data-id", id);
    this.virtualInput.setAttribute("name", id);
    for (let i = 0, l = options.length; i < l; i++) {
      const option = options[i];
      const [key, label] = (() => {
        if (typeof option === "string") {
          return [option, option];
        } else {
          return [option.value, option.label];
        }
      })();
      const optionName = `${name}-${key}`;
      const dataId = optionName;
      const elementId = `form_element-${dataId}`;
      const input = node('input', {
        type: 'checkbox',
        name: id,
        'data-name': optionName,
        'data-id': dataId,
        'data-label': label,
        id: elementId,
        value: key
      });
      input.addEventListener("change", () => {
        this.value = Object.keys(this.map).filter(key => this.map[key].checked).map(key => this.map[key].value);
      });
      this.map[key] = input;
      // if (data.default && data.default === key) {
      //   input.checked = true;
      // }
      const wrap = node('div', { "class": "field-checkbox" });
      wrap.appendChild(input);
      wrap.appendChild(node('label', { for: elementId }, label));
      fieldset.appendChild(wrap);

      this.fieldsElement.appendChild(fieldset);
    }
    this.virtualInput.addEventListener("change", () => {
      const inputs = Array.from(this.fieldsElement.querySelectorAll<HTMLInputElement>(`[name=${id}]`));
      inputs.forEach(input => input.checked = this.value && this.value.includes(input.value));
    });
    this.value = [];
  }

  public get mapKeys(): string[] {
    return Object.keys(this.map);
  }

  public subInput(key: string) {
    return this.map[key];
  }

  public focus() {
  }
}